import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Grid } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import { formatCNPJ } from '../../utils/formatters';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { CustomerOptions } from '../customer/types/customer.types';
import { useTranslation } from '../translation/TranslationContext';
import { useOrderBookStyles } from './styles/OrderBookStyles';
import { buildPlace } from './utils/formatters';

interface OrderCustomerOptionRendererProps {
  customer: CustomerOptions;
}

const OrderCustomerOptionRenderer = ({ customer }: OrderCustomerOptionRendererProps) => {
  const { translate } = useTranslation();
  const { classes } = useOrderBookStyles();

  return (
    <Grid
      container
      sx={{ width: '100%' }}
      test-id={`${ActiveOrderTestIds.ORDER_BOOK_CUSTOMERS_AUTOCOMPLETE_OPTION}-${customer.id}`}
    >
      <Grid className={classes.item} size={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'hidden',
            maxWidth: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              overflow: 'hidden',
              flex: 1,
              minWidth: 0,
              marginRight: 2,
            }}
          >
            <Typography noWrap variant="body2" color="textPrimary">
              {customer?.commercialName || translate(LangEnum.ORDER_BOOK_ORDER_WITHOUT_CUSTOMER)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              overflow: 'hidden',
              maxWidth: '50%',
            }}
          >
            <Typography
              noWrap
              variant="body2"
              sx={(theme) => ({
                fontWeight: theme.typography.fontWeightBold,
                wordBreak: 'normal',
              })}
            >
              {buildPlace(customer)}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid className={classes.item} size={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'hidden',
            maxWidth: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              overflow: 'hidden',
              flex: 1,
              minWidth: 0,
              marginRight: 2,
            }}
          >
            <Typography noWrap variant="caption" color="textSecondary">
              {customer?.companyName || translate(LangEnum.CUSTOMER_WITHOUT_COMMERCIAL_NAME)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              overflow: 'hidden',
              maxWidth: '50%',
            }}
          >
            <Typography noWrap variant="caption" color="textSecondary">
              {formatCNPJ(customer?.cpfcnpj)}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrderCustomerOptionRenderer;
